// dev_lp — shared check icon used in the "what is" and "benefits" cards.
import React from "react";

interface Props {
  className?: string;
}

const CheckIcon: React.FC<Props> = ({ className = "" }) => (
  <span
    className={`inline-flex items-center justify-center flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 text-blue-700 ${className}`}
    aria-hidden="true"
  >
    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  </span>
);

export default CheckIcon;
